import React from "react";
import { UserBadge } from "../user/UserBadge";
import { Link } from "react-router-dom";
import { gql, useMutation } from "@apollo/client";
import { formatDate } from "../../services/common/DateUtil";

const MARK_NOTIFICATION_AS_READ = gql`
  mutation mark_notification_as_read($id: ID!) {
    mark_notification_as_read(id: $id) {
      id
    }
  }
`;
export const Notification = ({ notification, onRead }) => {
  const link = getLink(notification);
  const title = getTitle(notification);

  const [markAsRead] = useMutation(MARK_NOTIFICATION_AS_READ);

  return (
    <Link
      to={link}
      className={`notification d-flex flex-row ${
        notification.read ? "read" : "unread"
      }`}
      onClick={async (e) => {
        if (!link) {
          e.stopPropagation();
          e.preventDefault();
        }
        await markAsRead({ variables: { id: notification.id } });
        if (onRead) {
          onRead();
        }
      }}
    >
      <div style={{ width: "50px" }} className="px-2">
        <UserBadge user={notification.author} />
      </div>
      <div className="flex-grow-1 fs-8">
        <div className="fw-bold">{title}</div>
        <div>{notification.content}</div>
        <div className="text-muted">{formatDate(notification.date)}</div>
      </div>
    </Link>
  );
};

const getTitle = (notification) => {
  if (notification.type === "event_result_liked") {
    return "Nouvelles réactions";
  }
  if (notification.type === "event_result_commented") {
    return "Nouveaux commentaires";
  }
  if (notification.type === "athlete_subscription_added") {
    return "Nouvel abonné";
  }
  return null;
};
const getLink = (notification) => {
  if (notification.type === "event_result_liked") {
    return `/event-results/${notification.resource_id}`;
  }
  if (notification.type === "event_result_commented") {
    return `/event-results/${notification.resource_id}`;
  }
  if (notification.type === "athlete_subscription_added") {
    if (notification.details?.athlete_id) {
      return `/athletes/${notification.details?.athlete_id}`;
    }
    return null;
  }
  return null;
};
